module.exports = __webpack_public_path__ + "img/dot-separator.b91cf0c2.svg";